var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{attrs:{"max-count":_vm.maxCount,"accept":_vm.accept,"before-delete":_vm.beforeDelete,"after-read":_vm.afterRead},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}})
}
var staticRenderFns = []

export { render, staticRenderFns }